// 导入组件，组件必须声明 name
import AceDataSourceFiledSelector from "./src/main";
// 为组件添加 install 方法，用于按需引入
AceDataSourceFiledSelector.install = function (Vue) {
  Vue.component(AceDataSourceFiledSelector.name, AceDataSourceFiledSelector);
};
export default AceDataSourceFiledSelector;
